export const drawConfig = {
  drawingFramesMax: 15
}